import React from 'react';
import { colors } from 'constants/colors';
import {
  BUBBLES,
  DEFAULT_GRAPH_DIMENSIONS,
  XCoordinates,
  getBubbleId,
} from '../constants';
import { TimelineBubbleType } from '../types';
import styles from '../TimeLineGraph.module.scss';

type Props = {
  bubble: TimelineBubbleType;
  onMouseOverBubble: (bubble: TimelineBubbleType) => void;
  onMouseOutBubble: () => void;
  onBubbleClick?: (bubble: TimelineBubbleType) => void;
};

const TimelineBubble: React.FC<Props> = ({
  bubble,
  onMouseOverBubble,
  onMouseOutBubble,
  onBubbleClick,
}) => {
  const {
    id,
    value,
    fillColor,
    secondaryColor,
    textColor = colors.primaryColor100,
    hasOpacity,
    position,
    isValueBottom,
  } = bubble;

  const centerY = DEFAULT_GRAPH_DIMENSIONS.height / 2;
  const yTop = centerY - 21;
  const yBottom = centerY + 32;
  const yCoordinate = isValueBottom ? yBottom : yTop;

  const x = XCoordinates[position];
  const xValueOffset = 18;

  const handleClick = () => {
    if (onBubbleClick) onBubbleClick(bubble);
  };

  return (
    <g
      onMouseOver={() => onMouseOverBubble(bubble)}
      onMouseOut={onMouseOutBubble}
      onClick={handleClick}
      style={{ cursor: onBubbleClick ? 'pointer' : 'default' }}
    >
      <circle
        id={getBubbleId(position)}
        cx={x}
        cy={centerY}
        r={BUBBLES.strokeWidth}
        fillOpacity={hasOpacity ? BUBBLES.fillOpacity : 1}
        fill={hasOpacity ? secondaryColor || fillColor : fillColor}
        stroke={hasOpacity ? fillColor : 'transparent'}
        strokeWidth={2}
      />
      <text
        x={x - xValueOffset}
        y={yCoordinate}
        fill={textColor}
        className={`${styles['graph-value-text']} timeline-value-${id}`}
      >
        {value}
      </text>
    </g>
  );
};

export default TimelineBubble;
